import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ExpenseFacade } from '../+state/expense/expense.facade';

@Component({
  selector: 'sd-portal-expense-audit',
  templateUrl: './expense.component.html',
  styleUrls: ['./expense.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpenseComponent implements OnInit {
  constructor(readonly expenseFacade: ExpenseFacade) {}

  ngOnInit() {
    this.expenseFacade.loadExpense();
  }
}
